"use client"

import { imageStorage } from "@/actions/image"
import { useGetSubTrainingByCode } from "@/actions/sub-training"
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel"
import { cn } from "@/lib/tailwind-utils"
import Autoplay from "embla-carousel-autoplay"
import Image from "next/image"
import Link from "next/link"
import { useRouter } from "next/navigation"
import { useRef, useState } from "react"
import { FaStar } from "react-icons/fa"
import SectionWrapper from "../common/section-wrapper"
import { Button } from "../ui/button"

export default function ShowDetailPelatihan({ sub_training_code }) {
  const [isActiveDesc, setActiveDesc] = useState("desc")
  const plugin = useRef(Autoplay({ delay: 5000, stopOnInteraction: true }))
  const {
    data: subTrainingData,
    isSuccess: isSuccessSubTraining,
    isLoading: isLoadingSubTraining,
  } = useGetSubTrainingByCode(sub_training_code)
  return (
    <SectionWrapper>
      <h1 className="text-[24px] font-bold leading-normal">
        Foto Pelatihan Diklat
      </h1>

      <div className="mx-auto mt-[20px] grid  grid-cols-7 gap-x-[20px] gap-y-8 md:gap-y-0">
        <div className="col-span-7 md:col-span-5 ">
          <div>
            <Carousel
              opts={{
                align: "start",
                loop: true,
              }}
              plugins={[plugin.current]}
              className="z-20   h-[300px]  w-full overflow-hidden rounded-[12px]  bg-white md:h-[400px]">
              <CarouselContent>
                {isSuccessSubTraining && (
                  <CarouselItem className="relative h-[400px]">
                    <Image
                      className={cn("cursor-pointer object-cover")}
                      alt=""
                      src={imageStorage(subTrainingData?.image)}
                      fill
                      style={{ objectFit: "cover" }}
                    />
                  </CarouselItem>
                )}
                {isLoadingSubTraining && (
                  <CarouselItem className="relative h-[400px] animate-pulse bg-slate-200"></CarouselItem>
                )}
              </CarouselContent>
              <CarouselPrevious />
              <CarouselNext />
            </Carousel>
          </div>
          <div className="mt-[24px] flex items-center gap-x-[24px] border-b">
            <h1
              onClick={() => setActiveDesc("desc")}
              className={cn(
                "cursor-pointer border-b-2 border-transparent text-[18px] leading-normal",
                {
                  "border-color-4 font-bold": isActiveDesc === "desc",
                },
              )}>
              Deskripsi
            </h1>
            <h1
              onClick={() => setActiveDesc("review")}
              className={cn(
                "cursor-pointer border-b-2 border-transparent text-[18px] leading-normal",
                {
                  "border-color-4 font-bold": isActiveDesc === "review",
                },
              )}>
              Ulasan
            </h1>
          </div>
          <div>
            {isActiveDesc === "desc" && (
              <div className="mt-[40px] flex flex-col gap-y-[20px]">
                <div>
                  <h1 className="text-[24px] font-bold leading-normal">
                    Ringkasan
                  </h1>

                  {isSuccessSubTraining && (
                    <p className="mt-[12px] text-[16px] leading-normal">
                      {subTrainingData.description}
                    </p>
                  )}
                  {isLoadingSubTraining && (
                    <p className="text-[16px] leading-normal">Loading...</p>
                  )}
                </div>
              </div>
            )}

            {isActiveDesc === "review" && (
              <div className="mt-[40px] flex flex-col gap-y-[20px] w-full">
                <div>
                  <h1 className="text-[24px] font-bold leading-normal">
                    Ulasan dari Alumni Pelatihan
                  </h1>
                  <div className="mt-[12px]  flex flex-col gap-y-[12px]">
                    {Array.from({ length: 1 }).map((_, index) => (
                      <div
                        key={index + 1}
                        className="min-h-[100px] w-full rounded-[12px] border pb-4 pr-4 pt-4">
                        <div className="grid grid-cols-9">
                          <div className="col-span-2 flex justify-center">
                            <div className="relative  h-[50px] w-[50px] overflow-hidden rounded-full ">
                              <Image
                                alt=""
                                src={"/images/arief.jpg"}
                                fill
                                className="object-cover"
                              />
                            </div>
                          </div>
                          <div className="col-span-7">
                            <div>
                              <p className="font-medium">Anonymous</p>
                              <p className="text-[14px]">Peserta Pelatihan </p>
                              <div className="my-[12px] flex items-center gap-x-[8px]">
                                <FaStar className="text-yellow-400" />
                                <FaStar className="text-yellow-400" />
                                <FaStar className="text-yellow-400" />
                                <FaStar className="text-yellow-400" />
                              </div>
                            </div>
                            <div>
                              Pelatihan ini sangat baik untuk mengasah skill
                              dalam bidang saya. Terimakasih BPPP Tegal.
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="col-span-7 flex h-max flex-col gap-y-[10px] rounded-[12px]  border p-[25px] md:col-span-2 ">
          <div className="flex flex-col gap-y-[12px]">
            <h1 className="text-[18px] font-semibold leading-normal">
              Tertarik dengan Pelatihan?
            </h1>
            <p className="text-[14px] leading-normal">
              Ayo bergabung dalam pelatihan diklat di BPPP Tegal! Bersama-sama,
              kita dapat mengembangkan diri dan mencapai potensi terbaik kita.
            </p>
          </div>
			<Button className="w-full" asChild>
			  <Link
				href={
				  String(sub_training_code).toLowerCase() === "dik6955"
					? "https://docs.google.com/forms/d/e/1FAIpQLScj0Tx-8rBUuFtwsQZCb8-LRNTyUyn5AK87gyj3_0bXEbMJeg/viewform"
					: `/pelatihan/${String(sub_training_code).toLowerCase()}/daftar`
				}
				target={
				  String(sub_training_code).toLowerCase() === "dik6955" ? "_blank" : "_self"
				}
				rel="noopener noreferrer">
				Daftar Pelatihan
			  </Link>
			</Button>
        </div>
      </div>
    </SectionWrapper>
  )  
}
